import { InjectionToken } from '@angular/core';
import { Environment } from '../types';

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
